import {FC, useCallback} from 'react';

import {ScraperItem} from '@shared/models/parser';

import {HousePreviewCard} from '@website_frontend/components/house_preview_card';
import {HousePreviewCardView} from '@website_frontend/components/house_preview_card_view';
import {VirtualizedGrid} from '@website_frontend/components/virtualized_grid';
import {DUMMY_ID} from '@website_frontend/lib/db_cache_descriptions';

interface VirtualizedHouseGridProps {
  ids: number[];
}

const DUMMY_ITEM: ScraperItem = {
  id: DUMMY_ID,
  description: new Uint8Array(),
  title: 'Dummy long title',
  price: 1_000_000,
  currency: 'EUR',
  typeLabel: 'House',
  areaM2: 100,
  nbBedrooms: 3,
  nbRooms: 4,
  parking: true,
  energyCertificate: 'A',
  landSurface: 100,
  city: 'Dummy City',
  estatePostalCode: '12345',
  country: 'Dummy Country',
  zoneCode: '12345',
  provinceId: '12345',
  estateType: 'Dummy Estate Type',
  estateSubType: 'Dummy Estate Sub Type',
};

export const VirtualizedHouseGrid: FC<VirtualizedHouseGridProps> = props => {
  const {ids} = props;

  const renderItem = useCallback((id: number) => <HousePreviewCard id={id} />, []);
  const renderMeasurementItem = useCallback(() => <HousePreviewCardView item={DUMMY_ITEM} />, []);
  const getItemKey = useCallback((id: number) => id, []);

  return (
    <VirtualizedGrid
      items={ids}
      renderItem={renderItem}
      renderMeasurementItem={renderMeasurementItem}
      getItemKey={getItemKey}
      minColumnWidth={300}
      gap={20}
    />
  );
};

VirtualizedHouseGrid.displayName = 'VirtualizedHouseGrid';
